import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api` });

export const money = (n, cur = "NZD") =>
  new Intl.NumberFormat("en-NZ", { style: "currency", currency: cur }).format(Number(n) || 0);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(", ");
  return typeof d === "string" ? d : "Something went wrong. Please try again.";
};
